import { Group, GroupFilterCondition } from "@fairfleet/geotab";

export default function createUserGroupFilter(
  companyGroups?: Group[],
  userGroupFilterCondition?: GroupFilterCondition,
  additionalAttributes?: { [key: string]: string | number | boolean | Date | string[] },
) {
  // userGroupFilterCondition seems to only work with more than one item ?!
  const useGroups =
    userGroupFilterCondition && userGroupFilterCondition.groupFilterConditions.length === 1;

  return {
    ...additionalAttributes,
    ...(companyGroups && useGroups ? { companyGroups } : {}),
    ...(!useGroups && userGroupFilterCondition ? { userGroupFilterCondition } : {}),
  };
}
